import { render, staticRenderFns } from "./ContentBlocks.vue?vue&type=template&id=2d7226a8&"
import script from "./ContentBlocks.vue?vue&type=script&lang=ts&"
export * from "./ContentBlocks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports